import Button from "./ButtonUi"

const Transform = () => {
    return (
        <div className="w-full flex flex-col items-center gap-6 bg-bottom-comp py-28">
            <h2 className="w-2/3 text-center text-4xl font-bold font-garamond">Transform the Way Your Customers Experience Your Brand</h2>
            <p className="w-1/2 text-center leading-loose font-montserrat font-demibold text-text-color">From AI-powered engagement to emotionally intelligent service — Outcess US helps you deliver experiences that drive loyalty, retention, and growth.</p>
            <Button variant="primary">Let&apos;s Build Your CX Advantage</Button>
        </div>
    )
}

export default Transform